import { useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";
import { PaletteMode } from "@mui/material";

export const useTheme = () => {
  const [mode, setMode] = useState<"light" | "dark">("light");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
      colorModeDark: () => {
        setMode(() => "dark");
        localStorage.setItem("prefersMode", "dark");
      },
      colorModeLight: () => {
        setMode(() => "light");
        localStorage.setItem("prefersMode", "light");
      }
    }),
    []
  );

  const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            background: {
              default: "rgb(246,247,249)",
            },
          }
        : {
            background: {
              default: "rgb(30,30,30)",
            },
          }),
      warning: {
        main: "#ffc72c",
      },
    },
  });

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return {
    colorMode,
    theme,
    mode,
  };
};
